<template>
  <section
    class="py-10"
    :style="{
      background: 'rgb(238 242 255 / 1)',
    }"
  >
    <div class="container mx-auto px-4">
      <div class="text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold mb-4">
          Kullanıcılarımız Ne Diyor?
        </h2>
        <p class="text-lg text-gray-600 max-w-2xl mx-auto">
          Binlerce kullanıcımız Gigcep ile her gün hediyeler kazanıyor.
        </p>
      </div>

      <div
        class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mt-10"
      >
        <div
          v-for="(testimonial, index) in testimonials"
          :key="index"
          class="bg-white rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:-translate-y-2 hover:shadow-xl"
          data-aos="fade-up"
          :data-aos-delay="index * 100"
        >
          <div class="flex items-center mb-4">
            <img
              :src="testimonial.image"
              :alt="testimonial.name"
              class="w-14 h-14 rounded-full object-cover mr-4"
            />
            <div>
              <h3 class="font-bold text-lg">{{ testimonial.name }}</h3>
              <div class="flex items-center">
                <template v-for="(num, i) in [...Array(5)]">
                  <Icon
                    name="material-symbols:star-rounded"
                    class="size-5 mr-1"
                    :style="{
                      color: i < testimonial.rating ? '#f59e0b' : '#d1d5db',
                      fill: i < testimonial.rating ? '#f59e0b' : '#d1d5db',
                    }"
                  />
                </template>
              </div>
            </div>
          </div>
          <p class="text-gray-600 italic">"{{ testimonial.quote }}"</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
const testimonials = ref([
  {
    id: 1,
    name: "Ayşe Yılmaz",
    quote:
      "Gigcep sayesinde boş zamanlarımda ödüller kazanıyorum. Basit gigleri tamamlayarak aldığım hediyeler gerçekten harika!",
    rating: 5,
    image:
      "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    id: 2,
    name: "Mehmet Kaya",
    quote:
      "Bu uygulama ile hediye çekleri kazanmak çok kolay. Arkadaşlarıma da tavsiye ettim, hepsi çok memnun.",
    rating: 5,
    image:
      "https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    id: 3,
    name: "Zeynep Demir",
    quote:
      "Gigcep'i üç aydır kullanıyorum ve şimdiye kadar birçok hediye kazandım. Kesinlikle denemeye değer!",
    rating: 4,
    image:
      "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
])
</script>
